export default __webpack_public_path__ + "static/image-three-accf968756189705b38e442895dd6d22.png";